import { expValEquals } from '@confluence/feature-experiments';
import { StatsigConfigurations } from '@confluence/statsig-configurations/entry-points/StatsigConfigurations.ts';

export type MigratedMacroExtensionKey =
	| 'blog-posts'
	| 'content-report-table'
	| 'contributors'
	| 'include'
	| 'pagetree'
	| 'pagetreesearch'
	| 'recently-updated'
	| 'widget'
	| 'contentbylabel'
	| 'popular-labels';

const getExperimentValue = (extensionKey: MigratedMacroExtensionKey): boolean => {
	switch (extensionKey) {
		case 'blog-posts':
		case 'content-report-table':
		case 'contentbylabel':
		case 'contributors':
		case 'include':
		case 'pagetree':
		case 'pagetreesearch':
		case 'recently-updated':
		case 'widget':
			return expValEquals('cc_rewrite_legacy_macros_phase_1', 'isEnabled', true);
		case 'popular-labels':
			return expValEquals('cc_rewrite_legacy_macros_phase_2', 'isEnabled', true);
		default:
			return false;
	}
};

const isMigratedMacroExtensionKey = (key: string): key is MigratedMacroExtensionKey =>
	[
		'blog-posts',
		'content-report-table',
		'contributors',
		'include',
		'pagetree',
		'pagetreesearch',
		'recently-updated',
		'widget',
		'contentbylabel',
		'popular-labels',
	].includes(key);

export const isMigratedMacroImplEnabled = (extensionKey: string): boolean => {
	const overrideList = StatsigConfigurations.getStringList(
		'cc_macro_override_to_legacy_renderer',
		[],
	);

	if (overrideList.includes(extensionKey)) {
		return false;
	}

	if (!isMigratedMacroExtensionKey(extensionKey)) {
		return false;
	}

	return getExperimentValue(extensionKey);
};
